import { Grid } from '@material-ui/core';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BottomActionFormBar from '../../../../common/components/buttons/bottomActionFormBar';
import CardContainer from '../../../../common/components/cards/cardContainer';
import {
  facilityExtraArrayInit,
  FacilityExtraDto,
} from '../../visitorInformation.dtos';
import FacilityExtras from '../cards/facilityExtras/facilityExtras';
import ResourcesCards from '../cards/facilityResources/resourcesCards';
import HoursCards from '../cards/hours/hoursCards';
import {
  facilityExtrasActions,
  updateFacilityExtraActions,
} from '../../visitorInformation.actions';
import { getType } from 'typesafe-actions';
import { rootSelector } from '../../../../common/selectors/selectors';

const VisitorInfoForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const systemInfo = rootSelector((state) => state.facilityInfo.content);

  const [dto, setDto] = useState<FacilityExtraDto[]>(facilityExtraArrayInit);

  useEffect(() => {
    dispatch({ type: getType(facilityExtrasActions.request) });
  }, [dispatch]);

  useEffect(() => {
    if (systemInfo.length > 0 && systemInfo != undefined) {
      setDto(systemInfo);
    } else {
      setDto(facilityExtraArrayInit);
    }
  }, [systemInfo]);

  const handleCancel = () => history.goBack();

  return (
    <Formik
      initialValues={{ content: dto }}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);
        }, 700);

        dispatch({
          type: getType(updateFacilityExtraActions.request),
          payload: values.content,
        });
      }}
      enableReinitialize={true}
    >
      {(props) => {
        const { values, isSubmitting, setFieldValue, handleSubmit } = props;
        return (
          <form onSubmit={handleSubmit} noValidate>
            <CardContainer
              title='Visitor Information'
              cards={
                <>
                  <Grid container item spacing={2}></Grid>
                  <Grid container item spacing={2}>
                    <ResourcesCards />
                  </Grid>
                  <Grid
                    container
                    item
                    spacing={2}
                    style={{ marginBottom: '50px' }}
                  >
                    <Grid item xs={12} sm={4}>
                      <HoursCards />
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      <FacilityExtras
                        extras={values.content}
                        onChange={setFieldValue}
                      />
                    </Grid>
                  </Grid>
                  
                  <BottomActionFormBar
                    cancelClickHandler={handleCancel}
                    submitting={isSubmitting}
                  />
                </>
              }
            />
          </form>
        );
      }}
    </Formik>
  );
};

export default VisitorInfoForm;
